import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LeverStateModel, UpdateFormLevers, AddLever, SetSelectedField, SendFilterUuid } from './lever.action';
import { Lever } from '../types/lever.type';

@State<LeverStateModel>({
  name: 'lever',
  defaults: {
    formValue: null,
    formValid: false
  }
})
@Injectable()
export class LeverState {
  @Selector()
  static getFormValue(state: LeverStateModel): Lever[] {
    return state.formValue ?? [];
  }

  @Selector()
  static isValid(state: LeverStateModel): boolean {
    return state.formValid;
  }

  @Selector()
  static getSelectedField(state: LeverStateModel): string[] {
    return (state.selectedField);
  }

  @Selector()
  static getSelectedUuid(state: LeverStateModel): string {
    return (state.selectedUuid);
  }

  @Action(UpdateFormLevers)
  updateFormObjectives({ getState, patchState }: StateContext<LeverStateModel>, { payload }: UpdateFormLevers): void {
    const state = getState();
    const newLevers = Array.isArray(payload.value) ? payload.value : [payload.value];
    patchState({
      formValue: [...(state.formValue ?? []), ...newLevers],
      formValid: payload.valid
    });
  }

  @Action(AddLever)
  addLever({ getState, patchState }: StateContext<LeverStateModel>, { lever }: AddLever) {
    const state = getState();
    patchState({
      formValue: [...(state.formValue ?? []), lever]
    });
  }

  @Action(SetSelectedField)
  setSelectedField({ patchState }: StateContext<LeverStateModel>, action: SetSelectedField) {
    patchState({
      selectedField: action.field
    });
  }

  @Action(SendFilterUuid)
  setSelectedUuid({ patchState }: StateContext<LeverStateModel>, action: SendFilterUuid) {
    patchState({
      selectedUuid: action.uuid
    });
  }

}
